import { render, staticRenderFns } from "./CasinoList.vue?vue&type=template&id=27ab1038&scoped=true&"
import script from "./CasinoList.vue?vue&type=script&lang=js&"
export * from "./CasinoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ab1038",
  null
  
)

export default component.exports